import { createGlobalStyle } from 'styled-components';
import iconsEot from './images/semantic-icons/icons.eot';
import iconsWoff2 from './images/semantic-icons/icons.woff2';
import iconsWoff from './images/semantic-icons/icons.woff';
import iconsTtf from './images/semantic-icons/icons.ttf';
import iconsSvg from './images/semantic-icons/icons.svg';
import brandIconsEot from './images/semantic-icons/brand-icons.eot';
import brandIconsWoff2 from './images/semantic-icons/brand-icons.woff2';
import brandIconsWoff from './images/semantic-icons/brand-icons.woff';
import brandIconsTtf from './images/semantic-icons/brand-icons.ttf';
import brandIconsSvg from './images/semantic-icons/brand-icons.svg';
import outlineIconsEot from './images/semantic-icons/outline-icons.eot';
import outlineIconsWoff2 from './images/semantic-icons/outline-icons.woff2';
import outlineIconsWoff from './images/semantic-icons/outline-icons.woff';
import outlineIconsTtf from './images/semantic-icons/outline-icons.ttf';
import outlineIconsSvg from './images/semantic-icons/outline-icons.svg';
const GlobalStyle = createGlobalStyle`
@font-face {
    font-family: Icons;
    src: url(${iconsEot});
    src: url(${iconsEot}#iefix)
        format('embedded-opentype'),
      url(${iconsWoff2}) format('woff2'),
      url(${iconsWoff}) format('woff'),
      url(${iconsTtf}) format('truetype'),
      url(${iconsSvg}#icons) format('svg');
  }
@font-face {
    font-family: brand-icons;
    src: url(${brandIconsEot});
    src: url(${brandIconsEot}#iefix)
        format('embedded-opentype'),
      url(${brandIconsWoff2}) format('woff2'),
      url(${brandIconsWoff}) format('woff'),
      url(${brandIconsTtf}) format('truetype'),
      url(${brandIconsSvg}#icons) format('svg');
  }
@font-face {
    font-family: outline-icons;
    src: url(${outlineIconsEot});
    src: url(${outlineIconsEot}#iefix)
        format('embedded-opentype'),
      url(${outlineIconsWoff2}) format('woff2'),
      url(${outlineIconsWoff}) format('woff'),
      url(${outlineIconsTtf}) format('truetype'),
      url(${outlineIconsSvg}#icons) format('svg');
  }
  `;

export default GlobalStyle;
